"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCartSelectedPackagingMethod = void 0;
const enums_1 = require("../../enums");
const trackGA4EventWithCleanUp_1 = require("../trackGA4EventWithCleanUp");
const PackagingMethodToTrackingMap = {
    [enums_1.PackagingMethod.Envelope]: 'printed voucher',
    [enums_1.PackagingMethod.Pdf]: 'pdf',
    [enums_1.PackagingMethod.GiftBox]: 'giftwrapping box',
};
function trackCartSelectedPackagingMethod(packagingMethod) {
    const eventLabel = packagingMethod ? PackagingMethodToTrackingMap[packagingMethod] : undefined;
    if (eventLabel) {
        (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
            eventData: {
                eventName: enums_1.GA4EventName.SelectPackagingMethod,
                feature_category: enums_1.GA4FeatureCategory.Cart,
                packaging_method: eventLabel,
            },
        });
    }
}
exports.trackCartSelectedPackagingMethod = trackCartSelectedPackagingMethod;
//# sourceMappingURL=trackCartSelectedPackagingMethod.js.map